const restrictPasteToDigits = event => {
    const pasteText = event.clipboardData.getData('text/plain');
    const nonNumbers = new RegExp(/\D/g);
    const matches = pasteText.match(nonNumbers);

    if (matches !== null) {
        event.preventDefault();
    }
};

export default restrictPasteToDigits;
